import { Col, Popover } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useUserPolicy, Actions, Subjects } from '../../../user-policy';
import { PAYROLL_ACTOR_KIND } from '../../../services/apontamentoProducao';
import Button from '../../atoms/Button';
import ImportarPlanilha from './ImportarPlanilha';

const UPDATE_POPOVER_DEFAULT =
  'O botão atualizar recalcula valores alterados na parametrização, projeções e cálculos de requisições processadas em outras requisições';
const UPDATE_POPOVER_M2M =
  'Esta requisição foi criada via API. O botão Atualizar recalcula dados do Apdata e pode interferir na integração ativa do cliente.';

function BotoesApontamento({
  onSalvar,
  onProcessar,
  onExportarExcel,
  onImportarExcel,
  headers,
  onCancelar,
  onDeletar,
  onAtualizar,
  onReabrir,
  exibicao,
  onBeforeUploadModal,
  requisicao,
  onRequestContractSigning,
}) {
  const { userAccount } = useUserPolicy();

  const canApproveReopening = userAccount?.ability?.can(Actions.APPROVE, Subjects.PAYROLL_REOPENING);
  const canDeletePayroll = userAccount?.ability?.can(Actions.DELETE, Subjects.PAYROLL);
  const reopenButtonLabel = canApproveReopening ? 'Reabrir' : 'Solicitar Reabertura';

  const isFromApi = requisicao.createdByActorKind === PAYROLL_ACTOR_KIND.M2M;

  return (
    <Col
      style={{
        display: 'grid',
        gridAutoFlow: 'column',
        columnGap: 16,
        marginLeft: 'auto',
        justifyContent: 'flex-end',
      }}
    >
      {requisicao.isEditable && (
        <Button
          type="primary"
          onClick={onProcessar}
        >
          Processar
        </Button>
      )}

      {exibicao.habilitarSolicitacaoAssinaturaContrato && (
        <Button onClick={onRequestContractSigning}>Notificar contrato pendente</Button>
      )}

      {requisicao.isEditable && <Button onClick={onSalvar}>Salvar Rascunho</Button>}

      {requisicao.isEditable && (
        <Popover
          title="Informações"
          content={isFromApi ? UPDATE_POPOVER_M2M : UPDATE_POPOVER_DEFAULT}
        >
          {isFromApi ? (
            <span style={{ display: 'inline-block' }}>
              <Button
                disabled
                onClick={onAtualizar}
              >
                Atualizar
              </Button>
            </span>
          ) : (
            <Button onClick={onAtualizar}>Atualizar</Button>
          )}
        </Popover>
      )}

      {exibicao.habilitarReabertura && <Button onClick={onReabrir}>{reopenButtonLabel}</Button>}

      {exibicao.habilitarExcluir && canDeletePayroll && (
        <Button onClick={onDeletar}>Excluir</Button>
      )}

      {exibicao.habilitarCancelar && <Button onClick={onCancelar}>Cancelar</Button>}

      <Button onClick={onExportarExcel}>Exportar Excel</Button>

      {requisicao.isEditable && (
        <ImportarPlanilha
          onBeforeUploadModal={onBeforeUploadModal}
          onUploadComplete={onImportarExcel}
          headers={headers}
        />
      )}
    </Col>
  );
}

BotoesApontamento.propTypes = {
  onSalvar: PropTypes.func.isRequired,
  onProcessar: PropTypes.func.isRequired,
  onCancelar: PropTypes.func.isRequired,
  onDeletar: PropTypes.func.isRequired,
  onExportarExcel: PropTypes.func.isRequired,
  onImportarExcel: PropTypes.func.isRequired,
  headers: PropTypes.shape({
    auth: PropTypes.string.isRequired,
    idRequisicao: PropTypes.number.isRequired,
    tipo: PropTypes.string.isRequired,
    idFolha: PropTypes.number.isRequired,
    validaQtdColab: PropTypes.bool.isRequired,
  }).isRequired,
  onAtualizar: PropTypes.func.isRequired,
  onReabrir: PropTypes.func.isRequired,
  onRequestContractSigning: PropTypes.func.isRequired,
  exibicao: PropTypes.shape(PropTypes.object.isRequired),
  onBeforeUploadModal: PropTypes.func.isRequired,
  requisicao: PropTypes.shape().isRequired,
};

BotoesApontamento.defaultProps = {
  exibicao: {},
};

export default BotoesApontamento;
